<template>
    <div class="content">
        <van-overlay :show="loading" @click="loading = false">
            <div class="wrapper" @click.stop>
                <van-loading type="spinner" color="#ffffff" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
    export default {
        props:{
            loading : {
                type: Boolean,
                default: () => false
            }
        }
    }
</script>

<style scoped lang="less">
/deep/ .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>